<script setup lang="ts">
/**
 * 无可用编辑器时的空白占位组件。
 */
</script>

<template>
  <div class="event-editor-blank" />
</template>
